import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { StorageService } from 'core-tsi';

export const accesoAppGuard: CanActivateFn = (route, state) => {

  const router = inject(Router)
  const session = StorageService.getSession()

  if (session && session.token) {
    return true
  }

  router.navigate(['/login'])
  return false
}
